import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Box } from '@mui/material';
import { FilterData } from 'types/types';
import {
  registeringPod,
  registeringPodDone,
  registeringPods,
} from 'features/dashboardsState';
import { filters } from 'features/filtersState';
import LocalForageService from 'services/LocalForageService';
import TrendChartComponent from './TrendChartComponent';
import GridComponent from './GridComponent';

interface Pod<T> {
  podId: string;
  filters: FilterData[];
  data: T;
  related_filters: string[];
  type: string;
}

interface PodProps {
  dashboardId: string;
  pod: Pod<any>;
}

interface DataFilter {
  filterId: string;
  values: { id?: string; name: string }[];
}

const PodData: React.FC<PodProps> = ({ pod, dashboardId }) => {
  const [loading, setLoading] = useState<boolean>(true);
  const filtersState = useSelector(filters);
  const lsService = new LocalForageService();
  const dispatch = useDispatch();
  const registeringPodsElements = useSelector(registeringPods);
  const [chartData, setChartData] = useState<any[]>([]);
  const [metadata, setMetadata] = useState<any>({});
  const getData = async (requestData) => {
    try {
      dispatch(registeringPod(pod.podId));
      const response = await lsService.getPodData(
        dashboardId,
        pod.podId,
        requestData
      );
      setMetadata(response.metadata);
      dispatch(registeringPodDone(pod.podId));
      setChartData(
        response.data.map((row, index) => ({
          id: index,
          ...row,
        }))
      );
      setLoading(false);
    } catch (error) {
      console.log('error');
    } finally {
      console.log('finally');
    }
  };
  const fetchPodData = () => {
    // {"dashboardId":"ni-ran-dsp-test","podId":"ni-ran-dsp-test-cell-trend","dataFilters":[{"filterId":"global_date_filter","values":[{"id":"2022-11-28T22:00:00.000Z|2022-11-29T22:00:00.000Z","name":"Tue Nov 29 2022 00:00:00 GMT+0200 (Eastern European Standard Time) to Wed Nov 30 2022 00:00:00 GMT+0200 (Eastern European Standard Time)"},{"id":"daily","name":"daily"}]},{"filterId":"global_technology_filter","values":[{"id":"GSM","name":"GSM","items":null,"contextInfo":null}]},{"filterId":"global_kpis_filter","values":[{"id":"RAN_GSM_2G_CALL_DROP_RATE","name":"2G Call Drop Rate","items":null,"contextInfo":null}]},{"filterId":"local_cell_filter","values":[{"id":"G09OS1693_00_A_Messaeid","name":"G09OS1693_00_A_Messaeid","items":null,"contextInfo":null}]},{"filterId":"local_cell_kpis_filter","values":[{"id":"RAN_GSM_2G_CALL_DROP_RATE","name":"2G Call Drop Rate","items":null,"contextInfo":null}]}],"contextInfo":{}}
    let podRequest: {
      dashboardId: string;
      podId: string;
      dataFilters: DataFilter[];
      contextInfo: object;
    } = {
      dashboardId: dashboardId,
      podId: pod.podId,
      dataFilters: [],
      contextInfo: {},
    };
    pod.related_filters.map((related_filter) => {
      const filter = filtersState.find(
        (f) => f.filterId === related_filter && f.dashboardId === dashboardId
      );
      if (
        filter &&
        filter.selectedValues &&
        filter.selectedValues.length > 0 &&
        filter.loaded
      ) {
        podRequest.dataFilters.push({
          filterId: filter.filterId,
          values: filter.selectedValues,
        });
      } else {
        return;
      }
    });
    if (podRequest.dataFilters.length === pod.related_filters.length) {
      getData(podRequest);
    }
  };

  useEffect(() => {
    if (registeringPodsElements.indexOf(pod.podId) === -1) {
      fetchPodData();
    }
    // eslint-disable-next-line
  }, [filtersState]);

  return (
    <>
      {loading ? (
        <div>Loading...</div>
      ) : (
        <Box className="dashboard-view-container">
          {pod.type === 'DashboardDescriptorPodTrendChartComponent' &&
            metadata && (
              <TrendChartComponent chartData={chartData} metadata={metadata} />
            )}
          {pod.type === 'DashboardDescriptorPodGridComponent' && metadata && (
            <GridComponent podData={chartData} columnsData={metadata} />
          )}
        </Box>
      )}
    </>
  );
};

export default PodData;
